/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63b67c15f5ce4acfe8885b27c8fde116>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/atlassian-intelligence
 * Usage guidance:
 * Single purpose - Reserved for Atlassian Intelligence apps or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const AtlassianIntelligenceIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "AtlassianIntelligenceIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 12v3h-1.5v-3zm-2.22-1.47-4 4-1.06-1.06 4-4zm8 2.94-1.06 1.06-4-4 1.06-1.06zM4 7.25v1.5H1v-1.5zm11 0v1.5h-3v-1.5zM6.53 5.47 5.47 6.53l-4-4 1.06-1.06zm8-2.94-4 4-1.06-1.06 4-4zM8.75 1v3h-1.5V1z"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var _default = exports.default = AtlassianIntelligenceIcon;